<style scopd>
.wangEditor-menu-container{
	background-color: #353942;
}
.wangEditor-menu-container .menu-group{
	border-right-color: #292c33;
}
.wangEditor-menu-container .menu-item a{
	color: #abacae;
}
.wangEditor-container{
	border-color: #292c33;
}
.content-container .content {
     margin-top: 0; 
     margin-left: 0; 
     padding: 0; 
}
</style>
<template>
	<div class="panel panel-default">
		<ly-fixheader :title="title" btn="save"></ly-fixheader>	
		<div class="panel-body">
			<form class="form-horizontal">
			  <div class="form-group">
			    <label class="col-sm-2 control-label">类型</label>
			    <div class="col-sm-10">
			      <label class="col-sm-2 control-label" style="text-align: left;" v-for="el in typeArr"><input type="radio" v-model="data.type" value="{{el.type}}" > {{el.type_name}}</label>
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">主标题 *</label>
			    <div class="col-sm-10">
			      <input type="text" class="form-control" placeholder="请输入文章主标题" v-model="data.title">
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">发布人</label>
			    <div class="col-sm-3">
			      	<select class="form-control" v-model="data.publisher">
			    		<option selected>路易云店运营团队</option>
			    		<option>路易云店稽核团队</option>
			    		<option>路易云店稽核团队</option>
			    	</select>
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">正文</label>
			    <div class="col-sm-10">
			    	<div id="editor" style="min-height:300px;">
			    	</div>
			       <!-- <textarea id="editor" v-model="data.content"></textarea> -->
			    </div>
			  </div>
			</form>
	    </div>
    </div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Common = require('../utils/Common.js');
	var editor = null;
	var data = {		
		type : 1,//文章类型
		type_name: "",
		title : '',//资讯的标题
		publisher : '',//发布者
		content : '', //内容	
	};//上传的数据
	//验证数据
	var ver = [
		[
			'type',Common.isNull,'请填写文章的类型'
		],
		[
			'title',Common.isNull,'请填写文章标题'
		],
		[
			'publisher',Common.isNull,'请填写文章发布者'
		],
		[
			'content',Common.isNull,'请填写文章内容'
		]

	];
	/**
	 * 初始化编辑器
	 */
	// var initEditor = function(){
 //        editor = new Simditor({
 //        	textarea: $('#editor')
 //        });
 //    };

	/**
	* 返回的处理
	*/
	var goback = function(vm){
		if(vm.isUpdate){
			vm.$dispatch('closeUpdate');
			vm.isUpdate = false;
		}else{
			Common.go('article_list');
		}
	};
	/**
	* 新增
	*/
	var create = function(vm){
		Http['article'].create({
			data : vm.data,
			succ : function(rs){
				data = {
					type : 1,//文章类型
					title : '',//资讯的标题
					publisher : '',//发布者
					content : '', //内容
				}
				Common.tipDialog("提交成功",1500,'success');
				goback(vm);
			},
			err  : function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});			
	};
	/**
	* 修改
	*/
	var save = function(vm){
		vm.data.status = 0;
		Http['article'].save({
			key : [vm.data.id],
			data : vm.data,
			succ : function(rs){
				for(var i = 0,len = vm.typeArr.length; i <= len; i++){
					if(vm.data.type == vm.typeArr[i]['type']) {
						vm.data.type_name = vm.typeArr[i]['type_name'];						
						break;
					}
				}
				Common.tipDialog("保存成功",1500,'success');
				//分发事件		
				goback(vm);
			},
			err  : function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});		
	};
	/**
	* ViewModel
	*/
	module.exports = {
		props : ['info'],//修改时传递过来的数据
		data : function () {
			return {
				typeArr: [],//文章类型
				type_name: "",//类型名称
				submitTxt : '保存并提交',
				data : data,
				isUpdate: false,
				title: '文章新增'//新增 or 修改 标题
			};
		},
		created : function(){
			var self = this;
			Http['articlecategory'].query({
				succ: function(rs) {
					self.typeArr = rs;			
				}
			});
			if(this.info != undefined){//判断是否有数据，没有表示为新增，有表示为修改
				this.title = "文章修改"
				this.isUpdate = true;
				this.$set('data',this.info);
				// this.data.type = this.info.type;
			}
		},
		components : {
			'ly-fixheader' : require('../components/Fixheader.vue')
		},
		ready: function() {
			// initEditor();
			var self = this;
			var inter = setInterval(function(){
				if(wangEditor){
					clearInterval(inter);
					wangEditor.config.printLog = false;
					editor = new wangEditor('editor');
					editor.config.uploadImgUrl = '/editorimgupload';//上传图片
					editor.config.emotions = {
					    // 第二组，id叫做'weibo'
					    'weibo': {
					        title: '微博表情',  // 组名称
					        data: [  // data 还可以直接赋值为一个表情包数组
					            // 第一个表情
					            {
					                'icon': 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/7a/shenshou_thumb.gif',
					                'value': '[草泥马]'
					            },
					            // 第二个表情
					            {
					                'icon': 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/60/horse2_thumb.gif',
					                'value': '[神马]'
					            }
					            // 下面还可以继续，第三个、第四个、第N个表情。。。
					        ]
					    }
					    // 下面还可以继续，第三组、第四组、、、
					};
					editor.create();
					editor.$txt.append(self.data.content);
				}
			},500);
					
		},
		events : {
			submit : function(){
				this.data.content = editor.$txt.html();
				var self = this;
				if(Common.validate(ver,this.data)){
					Common.tipDialog('保存中,请稍后...',0,'loading');
					if(self.isUpdate){
						save(self);
					}else{
						create(self);
					}
				}
			},
			goback : function(){
				goback(this);//这个是上面声明的函数
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** article_add.vue?28e7c8ef
 **/